import { Flex, Icon, Number, Tag, Text } from "components/common"
import { t } from "i18next"

const SuggestedAmountTags = ({ suggestedAmounts, onAmountClick }) => {
  if (!suggestedAmounts?.length) return null

  return (
    <Flex gap="8px" className="pb-8">
      <Text type="secondaryLight">{t("Suggestions")}:</Text>
      <div>
        {suggestedAmounts.map(element => (
          <Tag
            key={element.key}
            type="light"
            color="#f2faf4"
            onClick={() => onAmountClick(element)}
            tooltipText={element.props.value}
            style={{ border: "1px solid #9d9d9d" }}
            className="pb-4 pi-12 pointer"
            pill
          >
            <Icon icon="HiPlus" size={12} style={{ marginInlineEnd: 4, color: "#9d9d9d" }} />
            <Text type="secondaryLight">{element}</Text>
          </Tag>
        ))}
      </div>
    </Flex>
  )
}

export default SuggestedAmountTags
